import React, { createContext, ReactNode, useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { ModifyDashboardView } from '@futrli/views/views/reports/ModifyDashboardView/ModifyDashboardView';
import { useApiView } from '@futrli/views/hooks/useApiView';

import { useDuplicateDashboardForm } from '../hooks/use-duplicate-dashboard-form';

interface DuplicateDashboardContextProps {
  children?: ReactNode;
  dashboardId: string;
}

interface DuplicateDashboardContextValues {
  dashboardId: string;
  form: ReturnType<typeof useDuplicateDashboardForm>;
  organisationId: string;
  view: ModifyDashboardView;
  workspaceId: string;
}

const defaultState = ({} as unknown) as DuplicateDashboardContextValues;

export const DuplicateDashboardContext = createContext(defaultState);

export const DuplicateDashboardContextProvider = ({ children, dashboardId }: DuplicateDashboardContextProps) => {
  const { workspaceId = '', organisationId = '' } = useParams();

  const view = useApiView(
    useMemo(() => new ModifyDashboardView(workspaceId, organisationId, dashboardId), [
      workspaceId,
      organisationId,
      dashboardId
    ])
  );

  const form = useDuplicateDashboardForm(view.state.dashboard);

  const values = {
    dashboardId,
    form,
    organisationId,
    view,
    workspaceId
  };

  return <DuplicateDashboardContext.Provider value={values}>{children}</DuplicateDashboardContext.Provider>;
};

export const useDuplicateDashboardContext = () => useContext(DuplicateDashboardContext);
